/**
 * Gegevens verwerkingsverantwoordelijke / contact (AVG, Fase 2).
 * Standaard: Flexconsult24 (overschrijf via VITE_LEGAL_* in `.env` indien nodig).
 */

function envString(key: keyof ImportMetaEnv): string | undefined {
  const v = import.meta.env[key];
  return typeof v === 'string' && v.trim() !== '' ? v.trim() : undefined;
}

/** Handels-/productnaam */
export const LEGAL_PRODUCT_NAME = 'CalqTool™';

const DEFAULT_ENTITY = 'Flexconsult24';
const DEFAULT_ADDRESS_LINES = ['Pelmolenlaan 16', '3447 GW Woerden', 'Nederland'] as const;
const DEFAULT_KVK = '65102193';

/** Verwerkingsverantwoordelijke (bedrijfsnaam) */
export const LEGAL_ENTITY_NAME = envString('VITE_LEGAL_ENTITY_NAME') ?? DEFAULT_ENTITY;

/** Publiek contact (privacyverzoeken, algemene vragen) */
export const LEGAL_CONTACT_EMAIL = envString('VITE_LEGAL_CONTACT_EMAIL') ?? 'contact@calqtool.com';

const LINE1 = envString('VITE_LEGAL_ADDRESS_LINE1');
const LINE2 = envString('VITE_LEGAL_ADDRESS_LINE2');
const LINE3 = envString('VITE_LEGAL_ADDRESS_LINE3');

/** Bezoek-/postadres; zonder env: standaardadres Flexconsult24. */
export function getLegalAddressLines(): string[] {
  const fromEnv = [LINE1, LINE2, LINE3].filter((x): x is string => Boolean(x));
  if (fromEnv.length > 0) return fromEnv;
  return [...DEFAULT_ADDRESS_LINES];
}

export const LEGAL_KVK = envString('VITE_LEGAL_KVK') ?? DEFAULT_KVK;
export const LEGAL_BTW = envString('VITE_LEGAL_BTW');

export function legalMailtoHref(subject?: string): string {
  const base = `mailto:${encodeURIComponent(LEGAL_CONTACT_EMAIL)}`;
  if (!subject) return base;
  return `${base}?subject=${encodeURIComponent(subject)}`;
}
